/**
 * One-line footer copy for infinite-scroll DataTables.
 * Replaces paired "Showing …" + "All … loaded (N total)" footers when counts match.
 */
export function getInfiniteScrollListStatusMessage(options: {
  loadedCount: number;
  totalHint?: number | null;
  nounPlural: string;
  hasMore: boolean;
  isInitialLoading: boolean;
}): string | null {
  const { loadedCount, totalHint, nounPlural, hasMore, isInitialLoading } = options;
  if (loadedCount <= 0 || isInitialLoading) return null;

  const hasLargerTotal = totalHint != null && totalHint > loadedCount;

  if (hasMore) {
    return hasLargerTotal
      ? `Showing ${loadedCount} of ${totalHint} ${nounPlural}`
      : `Showing ${loadedCount} ${nounPlural}`;
  }

  if (hasLargerTotal) {
    return `Showing ${loadedCount} of ${totalHint} ${nounPlural} (all loaded)`;
  }

  return `All ${loadedCount} ${nounPlural} loaded`;
}
